import { match } from 'ts-pattern';
import { Button, ButtonLink, Typography } from '../../ui';
import * as animationData from './error-page.lottie.json';
import Lottie from 'react-lottie-player';

import { LinkOptions, useRouterState } from '@tanstack/react-router';

interface Props {
  title: string;
  description: string;
  action:
    | ({
        type: 'link';
        title?: string;
      } & LinkOptions)
    | {
        type: 'button';
        title?: string;
        onPress: () => void;
      };
}

export function ErrorPage(props: Props) {
  const isNavigating = useRouterState({
    select(state) {
      return state.isLoading;
    },
  });

  const { title, description, action } = props;

  return (
    <div className="p-64 flex flex-row gap-20 items-center">
      <div className="size-[285px]">
        <Lottie
          loop
          animationData={animationData}
          play
          style={{ width: 285, height: 285 }}
        />
      </div>

      <div className="flex flex-col">
        <Typography
          variant="display5"
          weight="semibold"
          className="text-primaryMain"
        >
          {title}
        </Typography>

        <Typography
          variant="body-m"
          weight="regular"
          className="text-primaryMain mt-8"
        >
          {description}
        </Typography>

        {match(action)
          .with({ type: 'button' }, ({ type, title, ...args }) => (
            <Button
              isDisabled={isNavigating}
              isLoading={isNavigating}
              size="small"
              className="w-fit mt-24"
              {...args}
            >
              {title ?? 'Terug'}
            </Button>
          ))
          .with({ type: 'link' }, ({ type, title, ...args }) => (
            <ButtonLink
              isDisabled={isNavigating}
              isLoading={isNavigating}
              size="small"
              className="w-fit mt-24"
              {...args}
            >
              {title ?? 'Terug'}
            </ButtonLink>
          ))
          .otherwise(() => null)}
      </div>
    </div>
  );
}
